"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sourcerJobTypes = exports.placementFeeJobTypes = exports.internalClientIds = exports.mergeHiringManagers = exports.hiringManagerDefaults = void 0;
const lodash_1 = require("lodash");
const job_constants_1 = require("../common/job-constants");
Object.defineProperty(exports, "internalClientIds", { enumerable: true, get: function () { return job_constants_1.internalClientIds; } });
Object.defineProperty(exports, "placementFeeJobTypes", { enumerable: true, get: function () { return job_constants_1.placementFeeJobTypes; } });
Object.defineProperty(exports, "sourcerJobTypes", { enumerable: true, get: function () { return job_constants_1.sourcerJobTypes; } });
exports.hiringManagerDefaults = {
    email: '',
    gender: 'other',
    linkedIn: '',
    name: {
        first: '',
        full: '',
        last: ''
    },
    phoneNumber: ''
};
function mergeHiringManagers(current, updated) {
    const existingIndexById = current.findIndex((manager) => manager.id === updated.id);
    const existingIndexByEmail = current.findIndex((manager) => manager.email === updated.email);
    let newCurrent = [...current];
    if (existingIndexById !== -1) {
        // Replace the existing hiring manager with the updated one
        newCurrent[existingIndexById] = updated;
    }
    else if (existingIndexByEmail !== -1) {
        // Merge the records, keeping the ID of the existing record
        const existingManager = newCurrent[existingIndexByEmail];
        newCurrent[existingIndexByEmail] = Object.assign(Object.assign(Object.assign(Object.assign({}, exports.hiringManagerDefaults), (0, lodash_1.pickBy)(existingManager)), (0, lodash_1.pickBy)(updated)), { id: existingManager.id // Ensure the ID remains the same
         });
    }
    else {
        // Add the new hiring manager
        newCurrent = [...newCurrent, updated];
    }
    return newCurrent;
}
exports.mergeHiringManagers = mergeHiringManagers;
//# sourceMappingURL=client.js.map